import { MessageRounded } from '@mui/icons-material';
import {
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  MenuItem,
} from '@mui/material';
import { useGetEQLExpression } from 'v2/core/repository/edge-server/eql/useGetEQLExpression';
import { ExpressionType } from 'v2/core/repository/eql/types';
import { combineWhereClauses } from 'v2/core/services/queryBuilder/combineWhereClauses';
import { OperationType } from 'v2/core/services/queryBuilder/whereClause';
import { useGetUser } from 'v2/core/services/user';
import { shallow } from 'zustand/shallow';
import { trackQuickFiltersEvents } from '../helpers/trackQuickFiltersEvents';
import { useChartTooltipStore } from '../hooks';

interface ViewFeedbackProps {
  isMenuItem?: boolean;
}

export function ViewFeedback({ isMenuItem }: ViewFeedbackProps) {
  const {
    tenant: { id: tenantID },
  } = useGetUser();
  const { dateRange, baseWhereClause, dataPointWhereClause, setData } =
    useChartTooltipStore(
      ({ baseWhereClause, dataPointWhereClause, dateRange, setData }) => ({
        baseWhereClause,
        dataPointWhereClause,
        dateRange,
        setData,
      }),
      shallow,
    );

  const whereClause = combineWhereClauses(
    baseWhereClause,
    dataPointWhereClause,
    OperationType.AND,
  );

  const eqlExpression = useGetEQLExpression({
    tenantID,
    eqlProps: {
      expressionType: ExpressionType.Aggregates,
      dateRange,
      whereClause,
    },
  });

  const showFeedbackDrawer = () => {
    const feedbackQueryContainer = {
      AggregatePeriod: 2,
      DateRange: dateRange,
      WhereClause: whereClause,
    };

    setData({
      shouldOpenFeedbackDrawer: true,
      feedbackQueryContainer,
    });
    trackQuickFiltersEvents({
      eventName: 'Quick Filter View Feedback',
      eqlExpression: eqlExpression.eql,
      triggerType: 'Chart',
    });
  };

  if (isMenuItem) {
    return (
      <MenuItem onClick={showFeedbackDrawer}>
        <ListItemIcon>
          <MessageRounded />
        </ListItemIcon>
        <ListItemText primary="View feedback" />
      </MenuItem>
    );
  }

  return (
    <ListItem divider disablePadding onClick={showFeedbackDrawer}>
      <ListItemButton>
        <ListItemIcon>
          <MessageRounded />
        </ListItemIcon>
        <ListItemText primary="View feedback" />
      </ListItemButton>
    </ListItem>
  );
}
